'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--MailWithCircle';

var EntypoMailWithCircle = function EntypoMailWithCircle(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M10,0.3999634c-5.3019409,0-9.5999756,4.2980957-9.5999756,9.6000366S4.6980591,19.5999756,10,19.5999756S19.5999756,15.3019409,19.5999756,10S15.3019409,0.3999634,10,0.3999634z M6.2313232,7h7.5195923c0.3988037,0,0.1935425,0.5117188-0.0234985,0.6430664c-0.217041,0.1308594-3.2213135,1.9470215-3.333313,2.0144043s-0.256958,0.0996094-0.402771,0.0996094c-0.145874,0-0.2908325-0.0322266-0.402771-0.0996094C9.4765625,9.5900879,6.472229,7.7739258,6.255188,7.6430664C6.038208,7.5117188,5.8328857,7,6.2313232,7z M14,12.5c0,0.2099609-0.251709,0.5-0.444458,0.5H6.444458C6.251709,13,6,12.7099609,6,12.5c0,0,0-3.5544434,0-3.6467285c0-0.0917969-0.001709-0.2114258,0.171875-0.109375c0.246521,0.1445312,3.265625,1.9250488,3.416687,2.013916c0.151001,0.0888672,0.256897,0.0995483,0.402771,0.0995483c0.145813,0,0.251709-0.0106812,0.402771-0.0995483s3.1875-1.8688965,3.434021-2.0134277C14.001709,8.642334,14,8.7619629,14,8.8537598C14,8.9460449,14,12.5,14,12.5z' })
    );
};

exports.default = EntypoMailWithCircle;
module.exports = exports['default'];